module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = 742
// module chunks = 9